import useApiCall from "hooks/useApiCall";
import { resetPassword } from "api/services/user-service";
import { IResetPasswordRequest } from "@api/models/request/IResetPasswordRequest";
import { IApiResponse } from "api/models/IApiResponse";

export const useResetPassword = () => {
    const { callAPI, loading } = useApiCall<IResetPasswordRequest, IApiResponse<any>>(resetPassword, 'resetPasswordPage.passwordResetSuccess');

    return { resetPassword: callAPI, resetPasswordPending: loading }
}